import CustomDepreciationWrapper from './CustomDepreciationWrapper'

export default CustomDepreciationWrapper
